import { useState } from "react";
import { useDispatch } from "react-redux";
import { useIsGroupV2Platform } from "hooks/useIsGroupV2Platform";
import { useUpdateQuery } from "hooks/useQuery";
import { openOnboardingWidget } from "store/slices/onboardingWidget";
import {
  SetupEntity,
  SetupModal,
} from "v2/components/entityDocuments/SetupModal";
import { PendingTaskRowShell } from "./PendingTaskRowShell";
import { COMPLETE_ONBOARDING_CONFIG } from "./pendingSectionConfig";
import { useOnboardingProfile } from "./useOnboardingProfile";

const ONBOARDING_WIDGET_QUERY = "onboarding_widget";
const ONBOARDING_WIDGET_OPEN = "open";

type ProfileSetupRowProps = {
  progress: number;
  isProgressReady: boolean;

  entities: SetupEntity[];
};

export const ProfileSetupRow = ({
  progress,
  isProgressReady,
  entities,
}: ProfileSetupRowProps) => {
  const dispatch = useDispatch();
  const isV2Platform = useIsGroupV2Platform();
  const { update } = useUpdateQuery();

  const [isSetupOpen, setIsSetupOpen] = useState(false);

  const { productName } = useOnboardingProfile();

  const pendingSuffix = isProgressReady ? ` (${100 - progress}% pending)` : "";

  const closeSetup = () => setIsSetupOpen(false);

  const handleAction = () => {
    if (isV2Platform) {
      setIsSetupOpen(true);
      return;
    }

    dispatch(openOnboardingWidget({ product: productName }));
    update({ query: ONBOARDING_WIDGET_QUERY, value: ONBOARDING_WIDGET_OPEN });
  };

  return (
    <>
      {isV2Platform && (
        <PendingTaskRowShell
          accent={COMPLETE_ONBOARDING_CONFIG.accent}
          title={`Finish setting up your profile${pendingSuffix}`}
          subtitle={COMPLETE_ONBOARDING_CONFIG.staticSubtitle ?? ""}
          actionLabel={COMPLETE_ONBOARDING_CONFIG.actionLabel}
          onAction={handleAction}
        />
      )}

      {isSetupOpen && entities.length > 0 && (
        <SetupModal open onClose={closeSetup} entities={entities} />
      )}
    </>
  );
};
